export default "__VITE_ASSET__BqnGQWWF__"